import { FC } from 'react'

import { Link } from '@remix-run/react'

import { IconArrowDown } from '~/components/ui/icons/arrow-down'
import { twMerge } from '~/lib/utils'

type AnchorLinksProps = {
  links: { label: string; id: string; isActive?: boolean }[]
  className?: string
}

export const AnchorLinks: FC<AnchorLinksProps> = ({ links, className }) => {
  return (
    <div
      className={twMerge(
        'flex h-anchorLinksHeight border-b border-grayBorder bg-white',
        className,
      )}
      role="navigation"
    >
      {links.map(({ id, label, isActive }) => {
        return (
          <Link
            className={twMerge(
              'flex flex-1 flex-col items-center gap-y-1 pb-1 pt-2',
              isActive && 'border-b-2 border-brand',
            )}
            key={id}
            to={`#${id}`}
          >
            <span
              className={twMerge(
                'text-body-s-bold',
                isActive ? 'text-brand' : 'text-grayText',
              )}
            >
              {label}
            </span>
            <IconArrowDown color={isActive ? 'brand' : 'gray'} />
          </Link>
        )
      })}
    </div>
  )
}
